import React from 'react'
import { useApp } from '../../context/AppContext'
import { Card, Progress } from '../../shared/components'
import { getMyPlan } from '../../api/settings.api'

function QuotaRow({ label, limit, usage, lang }) {
  // Paket tanpa batas: tanpa penyebut, progress bar tidak punya arti — dan
  // "N · —" terbaca seperti angka yang gagal dimuat, bukan seperti "tak
  // terbatas". Sebut saja apa adanya.
  if (limit == null) {
    return (
      <div>
        <div className="row between" style={{ alignItems: 'baseline' }}>
          <span className="small" style={{ fontWeight: 600 }}>{label}</span>
          <span className="tiny muted">
            {usage} · {lang === 'id' ? 'tak terbatas' : 'unlimited'}
          </span>
        </div>
      </div>
    )
  }
  const sisa = Math.max(0, limit - usage)
  return (
    <div>
      <div className="row between" style={{ alignItems: 'baseline' }}>
        <span className="small" style={{ fontWeight: 600 }}>{label}</span>
        <span className="tiny muted">{usage} / {limit}</span>
      </div>
      <Progress value={usage} max={limit} style={{ marginTop: 4 }} />
      <div className="tiny muted mt-1">
        {lang === 'id' ? `${sisa} tersisa` : `${sisa} left`}
      </div>
    </div>
  )
}

// Analog "Cuti Tahunan Balance" — sisa kuota peserta/program dari plan
// tenant. Tidak ada kartu ketiga ala "Who's Off today": tidak ada padanan
// data yang masuk akal di Gladhy (bukan sistem absensi/cuti), dikonfirmasi
// cukup 2 kartu untuk v1.
export function QuotaCards() {
  const { lang } = useApp()
  const [plan, setPlan] = React.useState(null)

  React.useEffect(() => {
    let cancelled = false
    getMyPlan().then((d) => { if (!cancelled) setPlan(d) }).catch(() => {})
    return () => { cancelled = true }
  }, [])

  if (!plan) return null

  return (
    <Card title={lang === 'id' ? 'Kuota Paket' : 'Plan Quota'} eyebrow={plan.label}>
      <div className="col gap-3">
        <QuotaRow
          lang={lang}
          label={lang === 'id' ? 'Peserta' : 'Participants'}
          limit={plan.limits?.participants ?? null}
          usage={plan.usage?.participants ?? 0}
        />
        <QuotaRow
          lang={lang}
          label={lang === 'id' ? 'Program' : 'Programs'}
          limit={plan.limits?.programs ?? null}
          usage={plan.usage?.programs ?? 0}
        />
      </div>
    </Card>
  )
}
